import React, { useContext, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import FormDataContext from 'integrations/contexts/FormDataContext';
import KeySecret from 'integrations/aws/authentication/KeySecret';
import Automatic from 'integrations/aws/authentication/Automatic';

import { Input } from 'components/bootstrap';
import AppConfig from 'util/AppConfig';


export const AWS_AUTH_TYPES = {
  automatic: 'Automatic',
  keysecret: 'Key & Secret',
};

const AuthWrapper = styled.div(
  ({ theme }) => css`
    margin: 0 0 21px 9px;
    padding: 3px 0 3px 21px;
    border-left: 3px solid ${theme.colors.gray[80]};
  `,
);

type AWSAuthenticationTypesProps = {
  onChange: (...args: any[]) => void;
};

const AWSAuthenticationTypes = ({ onChange }: AWSAuthenticationTypesProps) => {
  const { clearField, formData } = useContext(FormDataContext);

  const { awsAuthenticationType, awsAccessKey, awsSecretKey } = formData;

  let defaultAuthTypeValue;

  if (AppConfig.isCloud()) {
    defaultAuthTypeValue = AWS_AUTH_TYPES.keysecret;
  } else {
    defaultAuthTypeValue = awsAuthenticationType ? awsAuthenticationType.value : AWS_AUTH_TYPES.automatic;
  }

  const [currentType, setCurrenType] = useState(defaultAuthTypeValue);

  useEffect(() => {
    onChange({ target: { name: 'awsAuthenticationType', value: defaultAuthTypeValue } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isType = (type) => currentType === type;

  const handleTypeChange = (e) => {
    setCurrenType(e.target.value);
    onChange({ target: { name: 'awsAuthenticationType', value: e.target.value } });

    if (isType(AWS_AUTH_TYPES.automatic)) {
      clearField('awsAccessKey');
      clearField('awsSecretKey');
    }
  };

  return (
    <>
      {AppConfig.isCloud() ? (
        <KeySecret awsKey={awsAccessKey} awsSecret={awsSecretKey} onChange={onChange} />
      ) : (
        <>
          <Input
            type="select"
            name="awsAuthType"
            id="awsAuthType"
            onChange={handleTypeChange}
            label="AWS Authentication Type"
            defaultValue={currentType}>
            {Object.keys(AWS_AUTH_TYPES).map((type) => (
              <option value={AWS_AUTH_TYPES[type]} key={`option-${type}`}>
                {AWS_AUTH_TYPES[type]}
              </option>
            ))}
          </Input>

          <AuthWrapper>
            {isType(AWS_AUTH_TYPES.automatic) && <Automatic />}

            {isType(AWS_AUTH_TYPES.keysecret) && (
              <KeySecret awsKey={awsAccessKey} awsSecret={awsSecretKey} onChange={onChange} />
            )}
          </AuthWrapper>
        </>
      )}
    </>
  );
};

export default AWSAuthenticationTypes;
